export default __webpack_public_path__ + "static/media/broken.a52338c4.svg";